module.exports = __webpack_public_path__ + "img/IMG-20200722-WA0010.993f4b40.jpg";